import clsx from 'clsx';

import { getShortName } from '@/modules/rankings/ppr/helpers';
import { Team } from '@/modules/rankings/ppr/types';

interface TeamDisplayProps {
  team: Team;
  playerName?: string;
  label?: string;
  separator?: string;
}

export const TeamDisplay = ({ team, playerName, label, separator = ' / ' }: TeamDisplayProps) => {
  if (!team?.playerOne) return null;
  const input = (playerName || '').toLowerCase().trim();
  const playerOneFullName =
    `${team?.playerOne?.firstName ?? ''} ${team?.playerOne?.lastName ?? ''}`.toLowerCase();
  const playerTwoFullName =
    `${team?.playerTwo?.firstName ?? ''} ${team?.playerTwo?.lastName ?? ''}`.toLowerCase();

  const isPlayerOne = playerOneFullName.includes(input);
  const isPlayerTwo = playerTwoFullName.includes(input);

  return (
    <div className='flex items-center'>
      {label ? <p className='mr-1'>{`${label}:`}</p> : null}
      <p>
        <span className={clsx(isPlayerOne ? 'font-bold' : 'font-normal')}>
          <span className='sm:hidden'>{getShortName(team.playerOne)}</span>
          <span className='hidden sm:inline'>
            {`${team.playerOne.firstName} ${team.playerOne.lastName}`}
          </span>
        </span>
        {team.playerTwo ? (
          <span className={clsx(isPlayerTwo ? 'font-bold' : 'font-normal')}>
            <span className='sm:hidden'>{`${separator} ${getShortName(team.playerTwo)}`}</span>
            <span className='hidden sm:inline'>
              {`${separator} ${team.playerTwo.firstName} ${team.playerTwo.lastName}`}
            </span>
          </span>
        ) : null}
      </p>
    </div>
  );
};
